import { FunctionalComponent, h } from 'preact';
import { useTheme } from 'styled-components';

const OnIcon: FunctionalComponent = () => {
  const theme = useTheme();

  return (
    <svg width="100%" height="100%" viewBox="0 0 42 22" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M0 11C0 4.925 4.92 0 11.008 0h19.984C37.072 0 42 4.924 42 11c0 6.075-4.92 11-11.008 11H11.008C4.928 22 0 17.08 0 11z"
          fill={theme.color.secondary.default}
        />
        <path d="M31 20a9 9 0 100-18 9 9 0 000 18z" fill="white" />
        <path d="M8 6h10v10H8z" />
        <path
          d="M17.225 7.671c.192.173.208.47.035.662l-5.59 6.209a.467.467 0 01-.202.131l-.02.006a.467.467 0 01-.492-.133l-2.209-2.452a.469.469 0 01.697-.627l1.866 2.072 5.253-5.833a.469.469 0 01.662-.035z"
          fill={theme.typography.color.quaternary}
        />
      </g>
    </svg>
  );
};

export default OnIcon;
